import image3 from "../../images/sri-company-history-since-1980.png";
import "./Company.css";
import { Link } from "react-router-dom";
import { Row } from "react-bootstrap";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const Company = () => {
  useDocumentTitle("Company");
  return (
    <div className="company-main">
      <div className="d-flex align-items-center main-image">
        <h1>We Are SRI</h1>
      </div>

      <div className="d-flex align-items-center justify-content-center flex-wrap company-intro">
        <div className="company-intro-text">
          <h2>Serving governments and investors for more than 30 years.</h2>
        </div>
        <div className="company-intro-content">
          <p>
            At SRI, we are driven to create simple solutions for elected officials and investors. We work to relieve the
            tension that can come from tax sales or mortgage foreclosures. Using customizable technology, we are able to
            serve every corner of the country, and today, work with more than 300 local government offices
          </p>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-center company-history-header">
        <h2>Our History</h2>
      </div>

      <div className="d-flex align-items-center justify-content-center flex-wrap company-history-content">
        <div className="d-flex align-items-center justify-content-center flex-wrap company-history-text">
          <p>
            In 1990, SRI Founder, Jim E. Hughes was working for treasurers to collect delinquent taxes. Back then,
            treasurers didn't hold tax sales because they were held personally responsible for any errors.
          </p>
          <p>
            Jim saw an opportunity to help officials manage sales, save time, and streamline their workflow, so in 1990,
            he started Synergetic Resources Integration—SRI. He began assisting officials with noticing, advertising,
            and conducting tax sale auctions, holding himself responsible for all the details. This “cradle-to-grave”
            concept was welcomed by treasurers across several Indiana counties as it made the entire process of tax
            sales simpler.
          </p>
          <p>
            By 1992, SRI had six county clients and just four years later, the company was in 36 counties. Today, Jim's
            son, James B. Hughes, runs the company and we serve 85 of the 92 counties in Indiana and have expanded our
            services into five additional states.
          </p>
          <p>
            Our dedication to customer service has been unwavering since day one. Transparency, honesty, and maintaining
            open lines of communication with our customers is our driving force, now and always.
          </p>
        </div>

        <div className="d-flex align-items-center justify-content-center flex-wrap company-history-image-section">
          <img src={image3} alt="SRI Company History" className="img-fluid" />
        </div>

        <div className="d-flex align-items-center justify-content-center flex-column cta-section">
          <Row>
            <h2>Looking for a partner who has your best interests in mind?</h2>
          </Row>
          <Row className="cta-button-row">
            <Link to="/support" className="btn rounded-pill d-flex justify-content-center align-items-center cta-button">
              CONTACT US
            </Link>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Company;
